module.exports = require("./tr.d.ts");